<template>
<component :is='c_tag' :cols="md" class="flex_pad">
  <b><fs1-span>{{label}}</fs1-span></b>
  <slot></slot>
  <div @click="click?click():()=>{}" :class="[class_container||'valueContainer',(click?'pointer_hover':''),(class_name||'')]">
    <fs1-div v-for="(val, i) in split_text(value)" :key="i">
      {{ val }}
    </fs1-div>
  </div>
</component>
</template>
<script>
export default {
  props:['label','value','md','click','class_name','div','class_container','tag'],
  computed:{
    c_name(){ return this.div? 'div':'v-col'},
    c_tag(){ return this.tag || this.c_name },
  },
  methods:{split_text(a){ return a ?  (a+'').split('\n') : [a] }}
};
</script>
